import axios from 'axios'

export default axios.create({
    baseURL: 'https://adminvideo.tinghaiyun.com',
    timeout: 10000
})


// WEBPACK FOOTER //
// ./src/api/index.js